import React from "react"
import "./CountryCardCOT.scss"
import DataLoader, { years } from "../DataLoader"
import HistoricalBubbleGraph from "../HistoricalBubbleGraph/"
// import { useSmallWidthMode } from "../utils/smallWidthMode"
//import { factorImages } from "../images/factor_icons/factorImages"

export default function CountryCardCOT(props) {
  const {
    selectedCountry,
    selectedFactor,
    factorIndex,
    factorSelected,
    //scoreKey,
  } = props
  // const inSmallWidthMode = useSmallWidthMode()
  const historicalData = years
    .map((year) => {
      const countryDatum = DataLoader.dataByYear[year].countries.find(
        (country) => country.Country === selectedCountry,
      )
      return {
        year,
        data: countryDatum,
      }
    })
    .filter((datum) => datum.data)

  const minMaxYear = [
    historicalData[0].year,
    historicalData[historicalData.length - 1].year,
  ]
  const yearSpan = minMaxYear.join(" - ")

  const title = factorSelected ? (
    <span>
      <span className="fontCaps factorLabel">Factor {factorIndex + 1}</span> |{" "}
      {selectedFactor} for {selectedCountry}, {yearSpan}
    </span>
  ) : (
    `${selectedCountry} Overall Rule of Law Score Over Time, ${yearSpan}`
  )

  //const graphLeftMargin = inSmallWidthMode ? 60 : 0
  let cotText = null
  if (minMaxYear[0] === minMaxYear[1]) {
    cotText = (
      <span>
        {selectedCountry} was added to the <em>WJP Rule of Law Index</em> in{" "}
        {minMaxYear[1]}. Historical trends not yet available.
      </span>
    )
  } else {
    const scoreLabel = factorSelected ? selectedFactor : "overall rule of law"
    cotText = `${selectedCountry} scores for ${scoreLabel} from ${minMaxYear[0]} to ${minMaxYear[1]}. (Use the left menu to explore other scores.)`
  }
  return (
    <div className="countryCard countryCardCOT">
      <div className="title fontTitle">
        <a
          name="changeovertime"
          className="cardAnchor"
          href="#changeovertime"
          aria-hidden="true"
          tabIndex={-1}
        />
        {title}
      </div>

      <div className="cotContents">
        <div className="cotText">
          {cotText}

          <p>
            Scores are graphed to their unrounded values to demonstrate change
            over time.
          </p>
        </div>
        <div className="cotGraphs">
          <HistoricalBubbleGraph {...props} />
        </div>
      </div>
    </div>
  )
}
